$(function() {
    const comps = document.querySelectorAll('.property_search_component');
    [...comps].forEach(comp => {
        if (!comp) return;
        const ID = comp.dataset.id;
        const form = comp.querySelector('form');
        const radios = comp.querySelectorAll('input[type="radio"]');
        const min_price = form.querySelector('[name="min_price"]');
        const max_price = form.querySelector('[name="max_price"]');

        [...radios].forEach(rad => {
            rad.addEventListener('change', () => {
                form.setAttribute('action', `/properties/${buy_rent()}/${res_comm()}`);
            });
        });
        [...radios]
            .filter(rad => rad.getAttribute('name') === `property_search_component-buy_rent-${ID}`)
            .forEach(rad => {
                rad.addEventListener('change', () => {
                    const divisor = buy_rent() === 'buy' ? [1, 1] : [250, 1000];
                    const suffix = buy_rent() === 'buy' ? '' : ' per week';
                    [min_price, max_price].forEach(price => {
                        const label = price.getAttribute('name') === 'min_price' ? 'No Minimum Price' : 'No Price Limit';
                        while (price.firstChild) price.removeChild(price.firstChild);
                        price.appendChild(createOption(label, '0'));

                        for (let i = 5e4 / divisor[0]; i <= 2e6 / divisor[1]; i += 5e4 / divisor[0]) {
                            price.appendChild(createOption(`$${i.toLocaleString(undefined)}${suffix}`, i));
                        }
                    });
                });
            });
        const buy_rent = () => find_checked('buy_rent').getAttribute('value');
        const res_comm = () => find_checked('res_comm').getAttribute('value');
        const find_checked = name => [...comp.querySelectorAll(`input[name="property_search_component-${name}-${ID}"]`)].find(rad => rad.checked);
    });
});

function createOption(text, value) {
    const option = document.createElement('option');
    option.setAttribute('value', value);
    option.innerHTML = text;
    return option;
}